
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Title from 'components/Title/Title';
import Keyboard from 'components/Keyboard/Keyboard';
import Close from 'components/Close/Close';
import styles from './RideStart.module.scss';

const RideStart = observer(() => {

  // const [ type, setType ] = useState('scanner');
  const [ number, setNumber ] = useState('');
  const navigate = useNavigate();

  async function submit() {
    navigate(`/scooters/${number}`);
  }

  function onChange(value) {
    if (number.length >= 6) {
      return;
    }
    setNumber(number + value);
  }

  function onCorrectNumber() {
    setNumber(number?.slice(0, -1));
  }

  return (
    <div className={styles.container}>
      <Close to="/" />
      <div className={styles.header}>
        <Title>
          Start Ride
        </Title>
      </div>

      <div className={styles.note}>
        Enter a number, it's printed on a steering column
      </div>

      <div className={styles.numberCollage} />

      <div className={styles.number}>
        {number}
      </div>

      <Keyboard 
        onPress={onChange}
        onBack={onCorrectNumber}
        onSubmit={submit}
      />
      
      {/* <Scanner />

      <div className={styles.collage}>
        <div className={styles.collageBody} />
      </div> */}
    </div>
  );
});

export default RideStart;
